document.addEventListener( 'DOMContentLoaded', function () {
    const trustpilotStars = document.getElementById('trustpilotStars');
    const trustpilotReviewsInside = document.querySelector('#trustpilot-accordian-wrapper details summary');
  
    const trustpilotReviewsContent = document.querySelector('#trustpilot-accordian-wrapper details');
    trustpilotStars.addEventListener("click", function () {
      if (!trustpilotReviewsContent.hasAttribute('open')) {
        trustpilotReviewsContent.setAttribute('open', 'true');
        trustpilotReviewsInside.setAttribute('aria-expanded', 'true');
      }
      trustpilotReviewsContent.scrollIntoView({
        behavior: 'smooth',
        block: 'center' 
      });
    });

});





  
